import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const SimpleBarChart = ({ data, title, dataKey, nameKey }) => {
    return (
        <div style={{
            background: 'white',
            borderRadius: '10px',
            padding: '20px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            margin: '10px',
            flex: 1
        }}>
            <h3 style={{ marginBottom: '20px', color: '#333' }}>{title}</h3>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey={nameKey} />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey={dataKey} fill="#3498db" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default SimpleBarChart;